import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import userimg from "../../../Assets/images/userimg.jpg";

class Header extends Component {
  render() {
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    let { search_value, onSearch, placeholder, disabled, onEnter, hideSearch } = this.props;

    return (
      <header>
        <div className="flex">
          {hideSearch ? <div className="search_bar fitem-rinner licon"/> : <div className="search_bar fitem-rinner licon">
            <input type="text"
              value={search_value}
              onChange={(e) => {
                if (onSearch) {
                  onSearch(e)
                }
              }}
              placeholder={placeholder}
              readOnly={disabled}
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  onEnter({target: {value: search_value}})
                }
              }}
            />
            <div className="fitem-ricon"><i className="las la-search"></i></div>
          </div>}
          <div className="action_menu flex flex-end ai-center">

            {/* <button type="button" className="plain-btn add-btn"><i className="las la-plus-circle"></i></button> */}
            <span className="profile-wrap m-0">
              <Link to={'/settings'}> <figure className="mb-0">
                {user?.user?.photo ?
                  <img className="userimg" src={user.user.photo} alt="" />
                  : <img className="userimg" src={userimg} alt="" />}
              </figure>
              </Link>
            </span>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;